import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"

const getListSpk = async () => {
  const response = await api.get("/master/spk/index", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterSpkPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listSpk"],
    queryFn: getListSpk,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
